import { datapointStart } from "./constants";
import { DatapointIdStandardEnum } from "api/ux/src";
const isDefault = (measure, dimension) => {
    const measureLowerCase = measure.toLowerCase();
    if (measureLowerCase.startsWith(datapointStart.assetsDatapointStart)) {
        return dimension === DatapointIdStandardEnum.AssetAssetId;
    }
    if (measureLowerCase.startsWith(datapointStart.fundsInvestorDatapointStart)) {
        return dimension === DatapointIdStandardEnum.FundInvestorId;
    }
    if (measureLowerCase.startsWith(datapointStart.fundsDatapointStart)) {
        return dimension === DatapointIdStandardEnum.FundFundId;
    }
    if (measureLowerCase.startsWith(datapointStart.managerDatapointStart)) {
        return dimension === DatapointIdStandardEnum.ManagerManagerId;
    }
    if (measureLowerCase.startsWith(datapointStart.portfolioDatapointStart)) {
        return dimension === DatapointIdStandardEnum.PortfolioPortfolioId;
    }
    if (measureLowerCase.startsWith(datapointStart.instrumentDatapointStart)) {
        return dimension === DatapointIdStandardEnum.InstrumentInstrumentId;
    }
    return false;
};
const pushDefaultDimensions = (dimensionsMap) => {
    if (dimensionsMap === undefined || dimensionsMap.length === 0) {
        return [];
    }
    let i = 1;
    const newDim = dimensionsMap[0].configuredDimensions?.filter((x) => x.isDefault === 1) ?? [];
    while (i < dimensionsMap.length) {
        dimensionsMap[i].configuredDimensions = dimensionsMap[i].configuredDimensions?.filter((x) => x.isDefault === 1) ?? [];
        dimensionsMap[i].configuredDimensions?.forEach((dim) => {
            if (!newDim.some((s) => s.dimension === dim.dimension)) {
                newDim.push(dim);
            }
        });
        i += 1;
    }
    return newDim.map((d) => d.dimension);
};
export const getDimensionsMap = (measures, datapointsAllowedDimensions) => {
    const dimensionsMap = [];
    measures.forEach((m) => {
        const item = {
            configuredDimensions: datapointsAllowedDimensions
                .find((d) => m !== undefined &&
                (d.datapoint?.standard === m || d.datapoint?.custom === m))?.allowedDimensions?.map((r) => ({
                dimension: r.standard,
                isDefault: isDefault(m, r.standard) ? 1 : 0
            })),
            measure: m
        };
        dimensionsMap.push(item);
    });
    return dimensionsMap;
};
const onlyUnique = (value, index, array) => array.indexOf(value) === index;
const removeDuplicates = (dimensions) => dimensions.filter(onlyUnique);
const portfolioIdShouldBeUniqueDimension = (dimensions, measures) => {
    const anotherDimensionIncluded = dimensions.some((d) => d !== DatapointIdStandardEnum.PortfolioPortfolioId.toString());
    if (anotherDimensionIncluded) {
        const newDimensions = dimensions.filter((d) => d !== DatapointIdStandardEnum.PortfolioPortfolioId.toString());
        return { dimensions: newDimensions, measures };
    }
    return { dimensions, measures };
};
// Add exception rules to handle hedge cases
const exceptionsRules = [{ apply: portfolioIdShouldBeUniqueDimension }];
const applyExceptionsRules = (dimensions, measures, action) => {
    let finalDimensions = dimensions;
    let finalMeasures = measures;
    exceptionsRules.forEach(({ apply, excludedActions }) => {
        if (!excludedActions?.includes(action)) {
            const result = apply(finalDimensions, finalMeasures);
            finalDimensions = result.dimensions;
            finalMeasures = result.measures;
        }
    });
    return finalDimensions;
};
// Temporary. We should use datapoint instead of strings in dashboard designer
export const selectDimensionsBasedOnMeasures = (measures, datapointsAllowedDimensions, existingDimensions = [], action = "") => {
    const dimensionsMap = getDimensionsMap(measures, datapointsAllowedDimensions);
    let newDim = [];
    if (existingDimensions?.length === 0) {
        return removeDuplicates(pushDefaultDimensions(dimensionsMap));
    }
    if (existingDimensions) {
        measures.forEach((m) => {
            const dimensionsForMeasure = dimensionsMap.find((d) => d.measure === m);
            if (dimensionsForMeasure !== undefined) {
                dimensionsForMeasure.coveredBy = dimensionsForMeasure?.configuredDimensions
                    ?.find((s) => existingDimensions.includes(s.dimension) && s.isDefault === 1)?.dimension;
            }
        });
        const remainingMeasures = dimensionsMap.filter((f) => f.coveredBy === undefined);
        if (remainingMeasures.length === 0) {
            newDim = existingDimensions;
        }
        else {
            const missingDim = pushDefaultDimensions(remainingMeasures);
            newDim = [...existingDimensions, ...missingDim];
        }
        const unusedDimensions = existingDimensions
            .filter((d) => !dimensionsMap
            .some((dm) => dm !== undefined &&
            (dm.coveredBy === d ||
                dm.configuredDimensions?.some((confForDim) => confForDim.dimension === d && confForDim.isDefault))));
        newDim = newDim.filter((d) => !unusedDimensions.includes(d));
    }
    return applyExceptionsRules(removeDuplicates(newDim), measures, action);
};
